export default __webpack_public_path__ + "static/media/AirCycle-Pro-Monitor Clipped.1b7f99a4.png";